import { Deploy } from '@block-explorer/entities';
import { createAsyncAction } from 'typesafe-actions';
import { PaginatedResponse, PaginationParams } from '../../services';

export const getPaginatedDeploysAsync = createAsyncAction(
  'GET_PAGINATED_DEPLOYS_REQUEST',
  'GET_PAGINATED_DEPLOYS_SUCCESS',
  'GET_PAGINATED_DEPLOYS_FAILURE'
)<Partial<PaginationParams>, PaginatedResponse<Deploy>, string>();

export const getDeployByHashAsync = createAsyncAction(
  'GET_DEPLOY_BY_HASH_REQUEST',
  'GET_DEPLOY_BY_HASH_SUCCESS',
  'GET_DEPLOY_BY_HASH_FAILURE'
)<{ hash: string }, Deploy, string>();
